import { IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import StoreIcon from "@mui/icons-material/Store";
import DatagridCustom from "../General/DatagridCustom";

export default function BranchTable({
  branches,
  onEdit,
  canEdit = false,
  loading = false,
}) {
  const columns = [
    { field: "identification", headerName: "CUIT/DNI", flex: 1 },
    { field: "name", headerName: "Nombre", flex: 1 },
    { field: "alias", headerName: "Alias", flex: 1 },
    { field: "email", headerName: "Correo", flex: 1 },
    {
      field: "is_active",
      headerName: "Activa",
      width: 100,
      valueGetter: (value, row) => (row && row.is_active ? "Sí" : "No"),
    },
    ...(canEdit
      ? [
          {
            field: "actions",
            headerName: "Acciones",
            flex: 1,
            //width: 120,
            sortable: false,
            renderCell: (params) => (
              <IconButton color="primary" onClick={() => onEdit(params.row)}>
                <EditIcon />
              </IconButton>
            ),
          },
        ]
      : []),
  ];

  return (
    <DatagridCustom
      rows={branches}
      columns={columns}
      title="Listado de Sucursales"
      description="Administrar las sucursales registradas."
      icon={<StoreIcon sx={{ fontSize: 32 }} />}
      getRowId={(row) => row.id}
      loading={loading}
    />
  );
}
